import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Storage } from "../../storage";
import { flagNote } from "../../apis/venue-notes";
import { AddPhotoImageData } from "../../types";

export function usePostFlagNote() {
  const queryClient = useQueryClient();

  const { data, error, mutate, status } = useMutation({
    mutationFn: ({
        noteId,
        text,
        photos,
      }: {
        noteId: string;
        text: string;
        photos: AddPhotoImageData[];
      }) => {
      return flagNote({
        noteId,
        text,
        photos,
        token: Storage.getCurrentUserToken() || "",
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["loadVenueDetailsBySlug"],
        exact: false,
      });
    },
  });
  return {
    data,
    error,
    mutate,
    status,
  };
}
